import { render, staticRenderFns } from "./ServidorIndex.vue?vue&type=template&id=4fcb4534&scoped=true&"
import script from "./ServidorIndex.vue?vue&type=script&lang=js&"
export * from "./ServidorIndex.vue?vue&type=script&lang=js&"
import style0 from "./ServidorIndex.vue?vue&type=style&index=0&id=4fcb4534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb4534",
  null
  
)

export default component.exports